export default {
  welcome: 'Bem-vindo',
  subtitle: 'Veja o que aconteceu enquanto você estava fora',
  recentModelsTitle: 'Meus Modelos Acessados Recentemente',
  recentModelsLoading: 'Carregando seus modelos recentes...',
  recentModelsEmptyTitle: 'Ainda não há modelos acessados',
  recentModelsEmptyMessage: 'Os modelos aparecerão aqui conforme você os acessar',
  createdModelsTitle: 'Modelos Criados Recentemente',
  createdModelsLoading: 'Carregando modelos recentes...',
  createdModelsEmptyTitle: 'Ainda não há modelos criados',
  createdModelsEmptyMessage: 'Os modelos aparecerão aqui conforme forem criados',
  onlyMyModels: 'Mostrar apenas modelos criados por mim',
  recentPlansTitle: 'Planos Criados Recentemente',
  recentPlansLoading: 'Carregando planos recentes...',
  recentPlansEmptyTitle: 'Ainda não há planos criados',
  recentPlansEmptyMessage: 'Os planos dos seus modelos aparecerão aqui',
  onlyMyPlans: 'Mostrar apenas planos criados por mim',
  processing: 'Processando',
  recentEkrmsTitle: 'EKRMs Criados Recentemente',
  recentEkrmsLoading: 'Carregando EKRMs recentes...',
  recentEkrmsEmptyTitle: 'Ainda não há EKRMs criados',
  recentEkrmsEmptyMessage: 'Os EKRMs aparecerão aqui conforme forem criados',
  onlyMyEkrms: 'Mostrar apenas EKRMs criados por mim',
  dataUploadTitle: 'Atividade de Upload de Dados',
  dataUploadLoading: 'Carregando arquivos enviados recentes...',
  dataUploadEmptyTitle: 'Ainda não há arquivos enviados',
  dataUploadEmptyMessage: 'Os arquivos aparecerão aqui conforme forem enviados',
  onlyMyUploads: 'Mostrar apenas arquivos enviados por mim',
  dataBrief: 'Resumo de Dados',
  dataTemplate: 'Template de Dados',
  pendingApproval: 'Pendente de Aprovação',
  approved: 'Aprovado',
  modelProcessTitle: 'Atividade do Processo do Modelo',
  modelProcessLoading: 'Carregando atividade de etapas recente...',
  modelProcessEmptyTitle: 'Ainda não há atividade de etapas',
  modelProcessEmptyMessage: 'As atividades de etapas aparecerão aqui conforme ocorrerem',
  onlyMyActivities: 'Mostrar apenas minhas atividades',
  unknown: 'Desconhecido',
  modelTypeAdHoc: 'Ad-Hoc',
  modelTypeCustomStandard: 'Custom Padrão',
  modelTypeCustomEkrm: 'Custom EKRM',
  uploaded: 'Enviado',
  activityApproved: 'Aprovado',
  activityReversed: 'Revertido',
  activityUploaded: 'Enviado',
  activityFeedback: 'Feedback',
  activityFeedbackReply: 'Resposta a feedback'
}
